import React from 'react';
import { Link } from 'react-router-dom';
import './CTASection.css';

const CTASection = ({ darkMode }) => {
  return (
    <section className={`cta-section ${darkMode ? 'dark' : 'light'}`}>
      <div className="cta-content">
        <div className="cta-header">
          <h2 className="cta-title">
            ¿Datos repartidos y herramientas que no hablan entre sí?
          </h2>
          <p className="cta-subtitle">
            Cuéntanos en qué situación estás: mucho crecimiento de golpe, informes
            que no cuadran, papeleo duplicado si trabajas en una ONG o un ERP que
            el equipo evita. Te respondemos con claridad sobre qué atacar
            primero, sin inflar el proyecto.
          </p>
        </div>

        <div className="cta-main">
          <div className="cta-buttons">
            <Link to="/contacto" className="cta-button primary">
              Revisar mi caso
            </Link>
            <Link to="/contacto" className="cta-button secondary">
              Ver si encaja para mi empresa
            </Link>
            <Link to="/erp-para-pymes" className="cta-button secondary">
              Leer: ERP para pymes →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
